import { render } from "./FormSwitch.vue?vue&type=template&id=65e46878"
import script from "./FormSwitch.vue?vue&type=script&lang=js"
export * from "./FormSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__